import styles from './altus-plus.module.scss';

export default function AltusPlus({ variant = 'dark', className }: { variant?: 'light' | 'dark'; className?: string }) {
  return (
    <span className={`${styles.altusPlus} ${className ?? ''} ${variant === 'light' ? styles.altusPlusLight : ''}`}>
      Altus <span className={styles.plus}>Plus</span>
    </span>
  );
}
